/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
import { advancedSearch, advancedSecSort } from 'helpers/utils';
import ISearcher from 'ISearcher';
import ISorter from 'ISorter';
import UploadResource from './resource';

export class UploadSearcher implements ISorter<UploadResource, keyof UploadResource>, ISearcher<UploadResource, keyof UploadResource> {
  search = (
    item: UploadResource,
    value: any,
    type: keyof UploadResource,
  ) => advancedSearch(item, value, type, false);

  sort = (
    a: UploadResource,
    b: UploadResource,
    primary: keyof UploadResource,
    secondary?: keyof UploadResource,
  ) => advancedSecSort(a, b, primary, secondary);
}

export default UploadSearcher;
